import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data, enums } from '@app/memberships/state/store';
import { mapEnum } from '@app/helpers/memberships/formattedFields';

export default function(validate, form){

    const onBeforeClose = async () => {
        await data.membership_type.api.execute()
    }
    

    return {
        title     : 'Choose a membership type',
        component : rawDynamicImport(() => import('@app/memberships/components/form/stages/membership_type/MembershipType.vue')),
        isValid   : computed(
            () => validate({
                'membership_type'  : ['required'],
                'membership_group' : ['required']
            })
        ),
        data: computed(
            () => ({
                membership_type: form.value.membership_type?.id
            })
        ),
        onReloadData : async (progression, steps) => {
            form.value.membership_group = progression.data.membership_group
            form.value.membership_type  = progression.data.membership_type

            data.membership_type.api.parameters.value.membership_type_id = progression.data.membership_type?.id
    
            const previousHighestIndex = steps.getStageIndexFromName(progression.data.highest_step ?? progression.data.current_step)
            const tabIndex = steps.getStageIndexFromName('membership_type')
            
            //If the tabIndex is lower than previous highest we assume we got past this step
            if(tabIndex < previousHighestIndex){
                await onBeforeClose()
            }
        },
        listeners    : {
            onLoad: (props) => {
                if(props.membershipGroup){
                    form.value.membership_group = mapEnum(props.membershipGroup)

                    enums.memberships.membership_type.parameters.value.membership_group = props.membershipGroup?.value
                }

                if(props.superGroup){
                    enums.memberships.membership_type.parameters.value.super_group = props.superGroup
                    enums.memberships.membership_group.parameters.value.super_group = props.superGroup
                }
            },
            accordion: {
                onBeforeClose: onBeforeClose
            }
        }
    }
}